
export default {
    announcements: null,

    activeAnnouncement:null,

    manageAnnouncementDialog:false
}